import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8fafc', padding: '20px' }}>
      <div style={{ textAlign: 'center', maxWidth: '400px' }}>
        <div style={{ fontSize: '6rem', fontWeight: 900, color: '#e2e8f0', lineHeight: 1, marginBottom: '8px' }}>404</div>
        <h1 style={{ fontSize: '1.4rem', fontWeight: 800, color: '#1e293b', marginBottom: '8px' }}>Page introuvable</h1>
        <p style={{ color: '#64748b', fontSize: '0.95rem', marginBottom: '28px', lineHeight: 1.6 }}>
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate(-1)}
            style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: '#f1f5f9', color: '#374151', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}
          >
            ← Retour
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', backgroundColor: '#1e40af', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem' }}
          >
            Tableau de bord
          </button>
        </div>
      </div>
    </div>
  );
}
